
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.14.0
 * Query Engine version: e9771e62de70f79a5e1c604a2d7c8e2a0a874b48
 */
Prisma.prismaVersion = {
  client: "5.14.0",
  engine: "e9771e62de70f79a5e1c604a2d7c8e2a0a874b48"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.InviteScalarFieldEnum = {
  id: 'id',
  email: 'email',
  createdBy: 'createdBy',
  deletedBy: 'deletedBy',
  acceptedBy: 'acceptedBy',
  permission: 'permission',
  artistId: 'artistId',
  createdAt: 'createdAt',
  deletedAt: 'deletedAt',
  acceptedAt: 'acceptedAt'
};

exports.Prisma.ArtistInfoScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  billingEmail: 'billingEmail',
  stripeAccountId: 'stripeAccountId',
  firstName: 'firstName',
  lastName: 'lastName',
  phone: 'phone',
  bio: 'bio',
  managerName: 'managerName',
  personalWebsite: 'personalWebsite',
  recordLabel: 'recordLabel',
  instagram: 'instagram',
  twitter: 'twitter',
  facebook: 'facebook',
  tiktok: 'tiktok',
  spotify: 'spotify',
  appleMusic: 'appleMusic',
  soundcloud: 'soundcloud',
  bandcamp: 'bandcamp',
  beatport: 'beatport',
  mixcloud: 'mixcloud'
};

exports.Prisma.ThirdPartyAccessScalarFieldEnum = {
  key: 'key',
  name: 'name',
  notes: 'notes',
  modelIds: 'modelIds'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  sessionToken: 'sessionToken',
  userId: 'userId',
  expires: 'expires'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastSeen: 'lastSeen',
  hash: 'hash',
  walletAddress: 'walletAddress',
  emailVerified: 'emailVerified',
  role: 'role',
  image: 'image'
};

exports.Prisma.TeamUserScalarFieldEnum = {
  artistId: 'artistId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  permission: 'permission'
};

exports.Prisma.ReviewScalarFieldEnum = {
  id: 'id',
  status: 'status',
  reviewedAt: 'reviewedAt',
  reviewedById: 'reviewedById',
  baseReleaseId: 'baseReleaseId',
  mixReleaseId: 'mixReleaseId'
};

exports.Prisma.BaseReleaseScalarFieldEnum = {
  id: 'id',
  baseOrMix: 'baseOrMix',
  releaseType: 'releaseType',
  recordLabel: 'recordLabel',
  coverArtUrl: 'coverArtUrl',
  title: 'title',
  preferredReleaseDate: 'preferredReleaseDate',
  audioUrl: 'audioUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  artistId: 'artistId',
  tracks: 'tracks'
};

exports.Prisma.BaseReleaseDraftScalarFieldEnum = {
  id: 'id',
  baseOrMix: 'baseOrMix',
  releaseType: 'releaseType',
  recordLabel: 'recordLabel',
  tracks: 'tracks',
  coverArtUrl: 'coverArtUrl',
  title: 'title',
  audioUrl: 'audioUrl',
  preferredReleaseDate: 'preferredReleaseDate',
  artistId: 'artistId'
};

exports.Prisma.MixReleaseScalarFieldEnum = {
  id: 'id',
  baseOrMix: 'baseOrMix',
  mixType: 'mixType',
  recordLabel: 'recordLabel',
  coverArtUrl: 'coverArtUrl',
  title: 'title',
  subtitle: 'subtitle',
  preferredReleaseDate: 'preferredReleaseDate',
  audioUrl: 'audioUrl',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  createdById: 'createdById',
  artistId: 'artistId',
  tracks: 'tracks',
  language: 'language',
  parentalAdvisory: 'parentalAdvisory',
  performanceCountryOrCity: 'performanceCountryOrCity',
  performanceVenue: 'performanceVenue',
  primaryGenre: 'primaryGenre',
  secondaryGenre: 'secondaryGenre',
  performanceDate: 'performanceDate'
};

exports.Prisma.MixReleaseDraftScalarFieldEnum = {
  id: 'id',
  baseOrMix: 'baseOrMix',
  coverArtUrl: 'coverArtUrl',
  title: 'title',
  preferredReleaseDate: 'preferredReleaseDate',
  audioUrl: 'audioUrl',
  artistId: 'artistId',
  tracks: 'tracks',
  mixType: 'mixType',
  language: 'language',
  parentalAdvisory: 'parentalAdvisory',
  performanceCountryOrCity: 'performanceCountryOrCity',
  performanceVenue: 'performanceVenue',
  primaryGenre: 'primaryGenre',
  secondaryGenre: 'secondaryGenre',
  performanceDate: 'performanceDate'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Permission = exports.$Enums.Permission = {
  READ: 'READ',
  ADMIN: 'ADMIN'
};

exports.Role = exports.$Enums.Role = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};

exports.ReleaseType = exports.$Enums.ReleaseType = {
  ALBUM: 'ALBUM',
  EP: 'EP',
  SINGLE: 'SINGLE'
};

exports.MixType = exports.$Enums.MixType = {
  ARCHIVE: 'ARCHIVE',
  NEW_CONTENT: 'NEW_CONTENT',
  RADIO: 'RADIO'
};

exports.ParentalRating = exports.$Enums.ParentalRating = {
  CLEAN: 'CLEAN',
  EXPLICIT: 'EXPLICIT'
};

exports.Prisma.ModelName = {
  Invite: 'Invite',
  ArtistInfo: 'ArtistInfo',
  ThirdPartyAccess: 'ThirdPartyAccess',
  Account: 'Account',
  Session: 'Session',
  User: 'User',
  TeamUser: 'TeamUser',
  Review: 'Review',
  BaseRelease: 'BaseRelease',
  BaseReleaseDraft: 'BaseReleaseDraft',
  MixRelease: 'MixRelease',
  MixReleaseDraft: 'MixReleaseDraft'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
